import React from 'react';



const GHSymbol = ({className}) => {
  return (
    <span className={className}>GH<span style={{fontSize: '13px'}}>&#8373;</span></span>
  )
}

export default GHSymbol;